







import {Component, ComponentConfig, Product, Prop, Vue} from "@zoovu/runner-browser-api";
import {ProductButtonConfiguration} from "../configuration";
import {addToCartViaJS, addToCartViaUrl} from "./utils";

@Component({})
export default class ProductAddToCartView extends Vue {

    @Prop()
    product: Product;

    @ComponentConfig(ProductButtonConfiguration)
    productButtonConfiguration;

    get showAddToCartButton (): boolean {
        if ( !this.productButtonConfiguration.showAddToCartButton.enabled )
            return false;

        // hide atc button if attribute holding atc url isnt available for current product
        if (this.option === "url") {
            const addToCartUrlPropertyName = this.productButtonConfiguration.showAddToCartButton.url.attribute.name;
            return this.product.additionalProperties[addToCartUrlPropertyName] !== undefined;
        }

        return true;
    }

    addToCart () {
        switch (this.option) {
            case "javascript":
                const addToCartJavascript = this.productButtonConfiguration.showAddToCartButton?.javascript?.code || "";
                addToCartViaJS(addToCartJavascript, this.product);
                break;
            case "url":
                const addToCartUrlPropertyName = this.productButtonConfiguration.showAddToCartButton?.url?.attribute?.name || ""
                addToCartViaUrl(addToCartUrlPropertyName, true, [this.product]);
                break;
        }
    }

    get option(): string {
        return this.productButtonConfiguration.showAddToCartButton.option;
    }
}
